import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Checkbox from "components/library/Checkbox";
import StatusIcon from "dashboard/components/StatusIcon";

import styles from "./FilterStatusCheckbox.css";

import {
  addStatusFilter,
  removeStatusFilter,
  unsetFilter,
} from "dashboard/actions/filters";
import { getDashboardListAsync } from "dashboard/actions/list";

import { STATUS } from "config/constants";

const mapStateToProps = state => ({ filters: state.dashboard.filters });
const mapDispatchToProps = {
  addStatusFilter,
  removeStatusFilter,
  unsetFilter,
  getDashboardListAsync,
};

/**
 * @param {bool} [multipleActiveAllowed=true] - can two checks be selected at once
 */
class FilterStatusCheckbox extends Component {
  constructor(props) {
    super(props);

    this.isStatusFilterActive = this._isStatusFilterActive.bind(this);
    this.handleCheckboxToggle = this._handleCheckboxToggle.bind(this);
  }

  _isStatusFilterActive(status) {
    return this.props.filters.status
      ? this.props.filters.status.includes(status.slug)
      : false;
  }

  _handleCheckboxToggle() {
    const { status } = this.props;
    if (this.isStatusFilterActive(status)) {
      this.props.removeStatusFilter(status.slug);
    } else {
      if (!this.props.multipleActiveAllowed) {
        this.props.unsetFilter("status");
      }
      this.props.addStatusFilter(status.slug);
    }
    this.props.getDashboardListAsync();
  }

  render() {
    return (
      <div className={styles.root}>
        <Checkbox
          label={this.props.status.label}
          onChange={this.handleCheckboxToggle}
          isChecked={this.isStatusFilterActive(this.props.status)}
        />
        <StatusIcon status={this.props.status.slug} hasTooltip={false} />
      </div>
    );
  }
}

FilterStatusCheckbox.defaultProps = { multipleActiveAllowed: true };

FilterStatusCheckbox.propTypes = {
  status: PropTypes.oneOf(Object.values(STATUS)).isRequired,
  multipleActiveAllowed: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterStatusCheckbox);
